import { useEffect, useRef } from 'react';
import { createDialogWidget, DialogWidgetOpts, DialogWidget } from '@highloop/feedback';

export let useFeedbackDialog = (id: string, opts?: DialogWidgetOpts) => {
  let instanceRef = useRef<DialogWidget>();

  useEffect(() => {
    createDialogWidget(id, opts)
      .then(instance => {
        instanceRef.current = instance;
      })
      .catch(err => console.warn('[highloop-feedback]: Could not create widget', err));

    return () => {
      if (!instanceRef.current) return;
      instanceRef.current.destroy();
    };
  }, [id]);

  useEffect(() => {
    if (!instanceRef.current) return;
    instanceRef.current.setTheme(opts?.theme);
  }, [opts?.theme]);

  useEffect(() => {
    if (!instanceRef.current) return;
    instanceRef.current.setMeta(opts?.meta);
  }, [opts?.meta]);

  return {
    open: () => instanceRef.current?.open(),
    close: () => instanceRef.current?.close(),
    toggle: () => instanceRef.current?.toggle()
  };
};
